export default __webpack_public_path__ + "static/media/screen13.79ce1eac.svg";